import { AsYouType, CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";
import { getCountryByCode } from "../data/countries";

/** Format national input as the user types (dial code stays in the UI prefix). */
export function formatNationalNumber(
  raw: string,
  countryCode: CountryCode
): string {
  const formatter = new AsYouType(countryCode);
  const formatted = formatter.input(raw);
  const national = formatter.getNumber()?.formatNational();
  if (national) return national;

  // Keep the field national-only; dial code is shown beside the input
  return formatted.replace(/^\+\d[\d\s-]*?\s/, "").trim() || formatted;
}

/** Build the international display string used in the email signature. */
export function formatInternationalPhone(
  nationalNumber: string,
  countryCode: CountryCode
): string {
  const trimmed = nationalNumber.trim();
  if (!trimmed) return "";

  const parsed = parsePhoneNumberFromString(trimmed, countryCode);
  if (parsed?.isValid()) {
    return parsed.formatInternational();
  }

  const country = getCountryByCode(countryCode);
  return `${country.dial} ${trimmed}`;
}
